module.exports = __webpack_public_path__ + "Flag-56.f6e8c30c22abfc52af004ad0cc7d1588.svg";